import React from "react";
import { Outlet } from "react-router-dom";

const packageJson = require('../package.json');

function RootPage( {isEmbedded} ) {


    function closeDialog() {
        if (isEmbedded) {
            // eslint-disable-next-line no-undef
            RmAppJavaScriptInterface.closeDialog();
        }
    }


    const version = packageJson.version;

    return (
        <>
            <div className={"container"}>
                <Outlet />
            </div>
        </>
    );
}

export default RootPage;
